import React from 'react'
import styled from 'styled-components'
import { useFeatureIsOn } from 'utils/useGrowthBook'
import { useResizedMedia } from 'utils/useResizedMedia'
import { ArrowLink } from 'lib/ArrowLink'
import { LabelPill } from 'lib/LabelPill'
import { Text } from 'lib/Text'
import { usePromotedProductCampaign } from 'modules/brands/queries/usePromotedProductCampaign'
import { useCurrentBrand } from '../context/CurrentBrandProvider'

const IMAGE_SIZE = 134

const Container = styled.div`
  border: 1px solid var(--neutral-20);
  padding: var(--wide-grid-spacing);
  display: grid;
  grid-template-columns: auto ${IMAGE_SIZE}px;
  gap: 8px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`

const FreeLabel = styled(LabelPill)`
  margin-bottom: 8px;
`

const Title = styled(Text)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const ProductCampaign = () => {
  const { brand } = useCurrentBrand()
  const adsAreVisible = useFeatureIsOn('product-campaign-ads')
  const { data } = usePromotedProductCampaign({ variables: { brandId: brand.id }, skip: !adsAreVisible })

  const { imgAttributes, small } = useResizedMedia({
    mediaUrl: data?.brand?.promotedProductCampaign?.imageFullPath,
    width: IMAGE_SIZE,
    height: IMAGE_SIZE
  })

  if (!adsAreVisible || !data?.brand?.promotedProductCampaign) {
    return null
  }

  const campaign = data.brand.promotedProductCampaign

  return (
    <Container>
      <Content>
        <FreeLabel>Free!</FreeLabel>
        <Title weight="medium" size="s">
          {campaign.title}
        </Title>
        <ArrowLink
          url={`/brands/${brand.slug}/samples/${campaign.id}`}
          label="Get free product"
          arrowPosition="right"
          textProps={{ size: 'ps', weight: 'medium' }}
        />
      </Content>
      <img data-src={small} data-srcset={imgAttributes.dataSrcSet} className="lazyload" alt={campaign.title} />
    </Container>
  )
}
